import axios from '@/http.js';
export default {
    getTableList (url, param) {
        return axios.get(url, {params: param});
    },
}